var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"v-label theme--light mt-3 ml-6",attrs:{"align-self":"center"}},[_c('BaseHeaderStats',{attrs:{"context":"AzDistributors","typeStats":"LIST","alvqa":_vm.alvqa + '-list'}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }